export const BUSINESS_PARTNERS = {
  MULTISHOP: { partnerName: 'MULTISHOP', partnerCode: '8', key: 'multishop' },
  MAGNUM: { partnerName: 'MAGNUM', partnerCode: '7' },
  TTEC: { partnerName: 'TTEC', partnerCode: '6' },
  HORIZON: { partnerName: 'HORIZON', partnerCode: '5' },
  PEYMAN: { partnerName: 'PEY', partnerCode: '4' },
  ULKER: { partnerName: 'PLADIS', partnerCode: '2' },
  PMI: { partnerName: 'PMI', partnerCode: '' },
};
